import throttle from "lodash/throttle";
import React from "react";

import { useHandler } from "~/tools/use-handler";

export function useThrottle<TArgs extends Array<unknown>>(
	callback: (...args: TArgs) => void,
	wait = 500,
): (...args: TArgs) => void {
	const stableCallback = useHandler(callback);
	const debouncedCallback = React.useMemo(() => throttle(stableCallback, wait), [stableCallback, wait]);

	React.useEffect(() => () => debouncedCallback.cancel(), [debouncedCallback]);

	return debouncedCallback;
}
